import React from "react";

import { SiQuarto } from "react-icons/si";

const technologies = [
  { name: "R", iconClass: "devicon-r-plain colored" },
  { name: "Python", iconClass: "devicon-python-plain colored" },
  { name: "Git", iconClass: "devicon-git-plain colored" },
  { name: "GitHub", iconClass: "devicon-github-original colored" },
  { name: "Markdown", iconClass: "devicon-markdown-original colored" },
  { name: "Latex", iconClass: "devicon-latex-original colored" },
  { name: "HTML", iconClass: "devicon-html5-plain colored" },
  { name: "CSS", iconClass: "devicon-css3-plain colored" },
  { name: "Django", iconClass: "devicon-django-plain colored" },
  { name: "Bootstrap", iconClass: "devicon-bootstrap-plain colored" },
  { name: "Visual Studio", iconClass: "devicon-vscode-plain colored" },
  { name: "RStudio", iconClass: "devicon-rstudio-plain colored" },
];

const description =
  "These are some of the technologies I have used and have been learning recently";

const Tecnologies = () => {
  return (
    <section
      style={{
        background: `radial-gradient(circle at top left, #001f3f, transparent),
        radial-gradient(circle at bottom right, #001f3f, transparent)`,
        padding: " 10%",
        margin: "2rem auto",
        textAlign: "center",
        maxWidth: "100vw",
        boxSizing: "border-box",
        color: "white",
      }}
      id="tecnologies"
    >
      <h2>Tecnologies</h2>
      <p className="Medium"> {description}</p>
      <div className="logos-container">
        {technologies.map((tech, index) => (
          <div key={index} className="tech-icon" title={tech.name}>
            {tech.iconClass ? <i className={tech.iconClass}></i> : <span>{tech.name}</span>}
          </div>
        ))}
        <SiQuarto className="tech-icon" title="Quarto" />
      </div>
    </section>
  );
};

export default Tecnologies;
